<!--
 * @Author: 71
 * @Date: 2026-02-28 15:29:24
 * @LastEditTime: 2026-03-09 15:48:47
 * @LastEditors: 71
 * @Description: 
 * @FilePath: \aigoes-school-web\src\views\school\schoolHomeCommunication\SchoolHomeCommunicationList.vue
 * 苍天eye有，bug木有~~
-->
<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="4" :lg="6" :md="8" :sm="24">
            <a-form-item label="学生姓名">
              <a-input 
                v-model="queryParam.studentName" 
                placeholder="请输入学生姓名"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="6" :md="8" :sm="24">
            <a-form-item label="">
              <j-dict-select-tag
                style="width: 100%"
                placeholder="请选择年级"
                v-model="queryParam.gradeId"
                dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                :isShowEmpty="false"
                @select="(record) => selectTag('grade', record)"
                @clear="() => clear('grade')"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="6" :md="8" :sm="24">
            <a-form-item label="">
              <j-dict-select-tag
                style="width: 100%"
                placeholder="请选择班级"
                v-model="queryParam.classId"
                :dictCode="
                  'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                "
                :disabled="!queryParam.gradeId"
                :isShowEmpty="false"
                @select="(record) => selectTag('class', record)"
              />
              <!-- <j-dict-select-tag
                v-model="queryParam.classId"
                placeholder="请选择班级"
                :options="classOptions"
                :disabled="!queryParam.gradeId || queryParam.gradeId.length === 0"
              /> -->
            </a-form-item>
          </a-col>
          <a-col :xl="8" :lg="12" :md="12" :sm="24">
            <a-form-item label="时间范围">
              <a-range-picker :style="{minWidth: '256px'}" @change="onRangeChange" :value="acDateRange" />
            </a-form-item>
          </a-col>
          
          <a-col :xl="4" :lg="6" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">
                重置
              </a-button>
              <a-button
                type="primary"
                icon="download"
                style="margin-left: 8px"
                @click="handleExportExcel('家校沟通记录71')"
              >
                导出
              </a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px" v-if="false">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator" v-if="false">
      <a-button type="primary" icon="download" @click="">导出</a-button>
      <a-dropdown v-if="false">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete" />
            删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px" v-if="false">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>
        已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
        项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <!-- <template slot="sumaryInfoSlot" slot-scope="text, record">
          <div class="sumary-info-column">
            <div classs="left-img">
               <img
                :src="getImgView(text)"
                @click="showImgDialog(getImgView(text))"
                height="80px"
                alt
                style="max-width: 80px; font-size: 12px; font-style: italic"
              />
            </div>
            <div class="right-txt">
              <span class="title">{{record.title}}</span>
              <span class="time">{{record.beginTime + ' 至 ' + record.endTime}}</span>
            </div>
          </div>
        </template> -->
        <!-- <template slot="picUrl" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无图片</span>
          <img
            v-else
            :src="getImgView(text)"
            @click="showImgDialog(getImgView(text))"
            height="80px"
            alt
            style="max-width: 80px; font-size: 12px; font-style: italic"
          />
        </template> -->
        <!-- <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px; font-style: italic">无文件</span>
          <a-button v-else :ghost="true" type="primary" size="small" @click="preview(text)">
            预览视频
          </a-button>
        </template> -->
        <template slot="dateRangeSlot" slot-scope="text, record">
          <span v-if="!record.beginTime && !record.endTime" style="font-size: 12px; font-style: italic">-</span>
          <span>{{record.beginTime + '到' + record.endTime}}</span>
        </template>
        <template slot="publishSlot" slot-scope="text, record">
          <!-- <a-switch :checked="text" @change="changePublishStatus(record.id, text)"/> -->
        </template>

        <span slot="action" slot-scope="text, record">
          <!-- <a @click="publish(record)">发布</a>
          <a-divider type="vertical" /> -->
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->
  </a-card>
</template>

<script>
import '@/assets/less/TableExpand.less'
import SchoolActivityCalendarModal from './modules/SchoolActivityCalendarModal'
import SchoolActivityVideo from './modules/SchoolActivityVideo'
import JSelectMultiple from '../../../components/jeecg/JSelectMultiple.vue'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import { httpAction } from '@api/manage'
import { getAction, postAction, postActions } from '../../../api/manage'
import { message } from 'ant-design-vue'
import { defineComponent } from 'vue'
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'

export default {
  name: 'SchoolHomeCommunicationList',
  mixins: [JeecgListMixin],
  components: {
    SchoolActivityCalendarModal,
    JSearchSelectTag,
    SchoolActivityVideo,
    JSelectMultiple,
  },
  data() {
    return {
      description: '校园动态表管理页面',
      acDateRange: [], // 因为后端没有这个参数属性，所以放在data中
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '年级',
          align: 'center',
          dataIndex: 'gradeName',
          width: 100,
          // scopedSlots: { customRender: 'sumaryInfoSlot' },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          width: 100,
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          width: 100,
        },
        {
          title: '提交人',
          align: 'center',
          dataIndex: 'commitUser',
          width: 100,
        },
        {
          title: '角色',
          align: 'center',
          dataIndex: 'relation',
          width: 50,
        },
        {
          title: '提交原因',
          align: 'left',
          dataIndex: 'reason',
        },
        {
          title: '关注程度',
          align: 'left',
          dataIndex: 'attentiveness',
        },
        {
          title: '备注',
          align: 'left',
          dataIndex: 'remark',
        },
        {
          title: '家长提交时间',
          align: 'center',
          dataIndex: 'createTime',
          width: 100,
        },
        {
          title: '班主任回复',
          align: 'center',
          dataIndex: 'recordStatus',
          customRender: (text, record) => {
            if (!record.recordStatus) {
              return <span style="">无</span>;
            }
            // 否则显示原来的字典文本
            return '已知晓';
          }
        },
        {
          title: '班主任回复时间',
          align: 'center',
          dataIndex: 'knowTime',
          width: 100,
          customRender: (text, record) => {
            if (!record.knowTime) {
              return <span style="">-</span>;
            }
            return record.knowTime;
          }
        },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: 'center',
        //   scopedSlots: { customRender: 'action' },
        // },
      ],
      gradeOptions: [],  // 年级选项
      classOptions: [],  // 班级选项
      previewContent: '',      // 用于存储预览内容
      previewVisible: false,   // 控制预览模态框显示
      url: {
        list: '/aigoes/schoolParentConnect/listForManagement',
        exportXlsUrl: '/aigoes/schoolParentConnect/exportData',
        // list: '/aigoes/schoolActivityCalendar/list',
        // delete: '/aigoes/schoolActivityCalendar/delete',
        // deleteBatch: '/aigoes/schoolActivityCalendar/deleteBatch',
        // importExcelUrl: 'aigoes/schoolActivityCalendar/importExcel',
      },
    }
  },
  computed: {
    // importExcelUrl: function () {
    //   return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    // },
  },
  mounted() {
    // // 初始化 Video.js 播放器
    // this.player = videojs(this.$refs.myVideo, {
    //   // 设置播放器的选项，可根据需要进行配置
    // })
  },
  beforeDestroy() {
    // 销毁 Video.js 播放器
    // if (this.player) {
    //   this.player.dispose()
    // }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.loadDictGrades();
    },
    selectTag(type, record) {
      console.log('选择标签', record, type)
      switch (type) {
        case 'grade':
          this.$set(this.queryParam, 'classId', '')
          this.$set(this.queryParam, 'gradeId', record.value)
          this.currGradeName = record.text
          break
        case 'class':
          this.$set(this.queryParam, 'classId', record.value)
          this.currClassName = record.text
          break
      }
      // this.$set(this.formData, 'name', record.text)
    },
    clear(type) {
      console.log('清除标签', type)
      switch (type) {
        case 'grade':
          this.$set(this.queryParam, 'classId', '')
          this.$set(this.queryParam, 'gradeId', '')
          this.currGradeName = ''
          break
      }
    },
    loadDictGrades() { 
      // let dictCode = 'school_class,name,id,delete_flag=0'; // 班级
      let dictCode = 'school_grade,grade_name,id,delete_flag=0'; // 年级
      //优先从缓存中读取字典配置
      if (getDictItemsFromCache(dictCode)) {
        this.gradeOptions = getDictItemsFromCache(dictCode)
        return
      }
      //根据字典Code, 初始化字典数组
      ajaxGetDictItems(dictCode, null).then((res) => {
        if (res.success) {
          // let extraOptions = [{ value: 'ALL71', text: '全校', title: '全校' }];
          let extraOptions = [];
          this.gradeOptions = [...extraOptions, ...res.result];
        }
      })
    },
    onGradeChange(selectedValueStrs, selectedValueGrades) {
      // 获取当前选中的年级 ID
      const selectedGrades = selectedValueGrades || [];
      console.log(selectedGrades);
      if (selectedGrades && selectedGrades.length > 0) {
        // 构造班级查询条件
        let gradeIds = selectedGrades.join(',');
        let dictCode = `school_class,name,id,grade_id in (${gradeIds})`;
        let encodedDictCode = encodeURIComponent(dictCode);
        
        ajaxGetDictItems(encodedDictCode, null).then((res) => {
          if (res.success) {
            this.classOptions = res.result;
          }
        });
      } else {
        debugger;
        // 如果没有选择年级，则清空班级选项
        this.classOptions = [];
        this.queryParam.classId = [];
      }
    },
    handleExportExcel() {
      this.handleExportXls('家校沟通', { ...this.queryParam })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.queryParam.rangeType = 'range'
      this.acDateRange = dates;
      // this.$set(this.queryParam, 'acDateRange', dates);
      this.queryParam.beginTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.sumary-info-column {
  min-width: 300px;
  max-width: 500px;
  display: flex;
  flex-direction: row;
  .left-img {
    width: 80px;
    flex-shrink: 0;
  }
  .right-txt {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-evenly;
    padding-left: 10px;
    min-width: 0; /* 关键：允许子元素收缩 */
    // 超出省略号
    .title, .time {
      width: 100%;
      text-align: left;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap;
      word-wrap: break-word;
      word-break: break-all;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      
    }
  }
}
</style>
